import { Vue, Component, Prop } from "vue-property-decorator";
import * as ajax from "@brightspark/sparkling-ajax-js";

interface INews {
    publishDate: string;
    title: string;
    shortDescription: string;
    link: string;
}

interface ISlide {
    news: Array<INews>;
    display: boolean;
}

interface IModel {
    news: Array<INews>;
    slideSize: number;
    totalCount: number;
    dataUrl: string;
}

interface IComponentData {
    slides: Array<ISlide>,
    allNews: Array<INews>;
    currentSlideNo: number,
    articlesPerSlide: number,
    dataUrl: string,
    isDataRequestInProgress: boolean;
}

@Component
export default class NewsSlider extends Vue {
    @Prop() model: IModel;
    private _data: IComponentData;
    private _articlesPerSlide: number;
    private _totalCount: number;

    data() {
        this._articlesPerSlide = this.model.slideSize;
        this._totalCount = this.model.totalCount;

        return {
            slides: this.calulateSlides(this.model.news, this.getArticlesPerSlideAmount()),
            currentSlideNo: 1,
            articlesPerSlide: this.getArticlesPerSlideAmount(),
            dataUrl: this.model.dataUrl,
            isDataRequestInProgress: false,
            allNews: this.model.news
        } as IComponentData;
    }

    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.calculateVisibleSlide();
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }

    next() {
        this.slideForward();
    }

    prev() {
        this.slideBackwards();
    }

    slideForward() {
        var slidesShown = this._data.currentSlideNo * this._data.articlesPerSlide;

        if (slidesShown >= this._totalCount
            || this._data.isDataRequestInProgress) {
            return;
        }

        this._data.currentSlideNo++;
        this.calculateVisibleSlide();

        if (this._data.slides.length >= this._data.currentSlideNo) {
            return;
        }

        var data = {
            nextSlide: Math.ceil(slidesShown / this._articlesPerSlide)
        }

        this._data.isDataRequestInProgress = true;
        ajax(this._data.dataUrl, { dataType: "json", method: "post", data: data })
            .done((res: Array<INews>) => {
                if (!res) {
                    return;
                }

                for (let i = 0; i < res.length; i++) {
                    this._data.allNews.push(res[i]);
                }

                this.updateSlides();
                this._data.isDataRequestInProgress = false;
            });
    }

    slideBackwards() {
        if (this._data.currentSlideNo === 1) {
            return;
        }
        this._data.currentSlideNo--;
        this.calculateVisibleSlide();
    }

    getArticlesPerSlideAmount() {
        let screenSize = {
            mobileSmall: 650,
            mobile: 767,
            tablet: 1023
        };

        let articlesPerSlide = this._articlesPerSlide;
        let currentWindowWidth = window.innerWidth;
        if (currentWindowWidth < screenSize.tablet) {
            articlesPerSlide = 2;
        }
        if (currentWindowWidth < screenSize.mobile) {
            articlesPerSlide = 2;
        }
        if (currentWindowWidth < screenSize.mobileSmall) {
            articlesPerSlide = 1;
        }
        return articlesPerSlide;
    }

    handleResize(e) {
        var articlesPerSlide = this.getArticlesPerSlideAmount();
        if (this._data.articlesPerSlide === articlesPerSlide) {
            return;
        }

        this._data.articlesPerSlide = articlesPerSlide;
        this.calulateSlides(this._data.allNews, articlesPerSlide);
    }

    updateSlides() {
        this.calulateSlides(this._data.allNews, this._data.articlesPerSlide, false);
    }

    calulateSlides(articles: Array<INews>, articlesPerSlide: number, resetCurSlide: boolean = true): Array<ISlide> {
        let slides = [] as Array<ISlide>;
        let currentSlide: ISlide = {
            news: [] as Array<INews>,
            display: false
        } as ISlide;

        for (let i = 0; i < articles.length; i++) {
            if (i % articlesPerSlide === 0) {
                currentSlide = {
                    news: [] as Array<INews>,
                    display: false
                } as ISlide;

                slides.push(currentSlide);
            }
            currentSlide.news.push(articles[i]);
        }

        if (this._data) {
            if (resetCurSlide) {
                this._data.currentSlideNo = 1;
            }
            this._data.slides = slides;
            this.calculateVisibleSlide();
        }
        return slides;
    }

    calculateVisibleSlide() {
        for (let i = 0; i < this._data.slides.length; i++) {
            this._data.slides[i].display = this._data.currentSlideNo - 1 === i;
        }
    }

    get longestNews(): INews | null {

        if (!this._data.slides.length) {
            return null;
        }

        let longestArticle = this._data.slides[0].news[0];
        let longestArticleLenght: number = longestArticle.shortDescription.length + longestArticle.title.length;

        for (let i = 1; i < this._data.slides.length; i++) {
            let slide = this._data.slides[i];
            for (let j = 1; j < slide.news.length; j++) {
                let news = slide.news[j];

                let isLonger = news.shortDescription.length + news.title.length
                    > longestArticleLenght;

                if (isLonger) {
                    longestArticle = news;
                }
            }
        }
        return longestArticle;
    }

    get nextButtonClass(): Array<string> {
        var classList = ["landing__news__control", "landing__news--next"];

        if (this._data.currentSlideNo * this._data.articlesPerSlide >= this._totalCount) {
            classList.push("landing__news--disabled");
        }
        return classList;
    }

    get prevButtonClass(): Array<string> {
        var classList = ["landing__news__control", "landing__news--prev"];

        if (this._data.currentSlideNo < 2) {
            classList.push("landing__news--disabled");
        }
        return classList;
    }
}


// WEBPACK FOOTER //
// ./www/js/Components/NewsSlider/NewsSlider.ts